import React from 'react'

import { ClearAdornment } from '../../../UI/Adornments/ClearAdornment'

import { GenericInputAction } from '../../../UI/GenericInputAction/GenericInputAction'

import { putAwayActions } from '../../actions/putAwayActions'

import { usePutAway } from '../../Context/usePutAway'

interface SKUInputProps {
  inputRef?: React.Ref<JSX.Element> | undefined
}

export const SKUInput: React.FC<SKUInputProps> = ({ inputRef }) => {
  const { state } = usePutAway()
  const { skuEan, ubication } = state
  const {
    handleChangeGenericInput,
    handleResetGenericInput,
    validateSKUInput
  } = putAwayActions()

  React.useEffect(() => {
    if (skuEan.status === 'success') {
      document.getElementById('inputQty')?.focus()
    }

    if (skuEan.status === 'default') {
      document.getElementById('skuEan')?.focus()
    }
  }, [skuEan.status])

  const adornment = (
    <ClearAdornment
      onClick={() => handleResetGenericInput('setSkuEan')}
      disabled={skuEan.status === 'success'}
    />
  )

  return (
    <GenericInputAction
      name='skuEan'
      id='skuEan'
      placeholder='Escanea SKU/EAN'
      disabled={ubication.status !== 'success'}
      onChange={(e) => handleChangeGenericInput(e, 'setSkuEan')}
      value={skuEan.value}
      adornment={adornment}
      status={skuEan.status}
      error={skuEan.error.length > 0}
      errorText={skuEan.error}
      onBlur={() => {}}
      onKeyPress={(e) => {
        if (e.key === 'Enter') {
          validateSKUInput(e)
        }
      }}
      ref={inputRef}
    />
  )
}
